/**
 * 自定义舆情路由
 * 2019-01-17
 * Qian.qianchen
 */
"use strict";
angular.module("customSentimentRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("front.plan.realtimeclues.suddenclues.customsentiment.emphasissentiment", {
        url: "/emphasissentiment?nav",
        views: { //重点舆情
            "main@front.plan.realtimeclues.suddenclues": {
                templateUrl: "./planningCenter/realTimeClues/suddenClues/customSentiment/emphasisSentiment/emphasisSentiment_tpl.html",
                controller: "emphasisSentimentController"
            }
        }
    }).
    state("front.plan.realtimeclues.suddenclues.customsentiment.customdetail", {
        url: "/customdetail?navid",
        views: { //自定义舆情
            "main@front.plan.realtimeclues.suddenclues": {
                templateUrl: "./planningCenter/realTimeClues/suddenClues/customSentiment/customDetail/customDetail_tpl.html",
                controller: "customDetailController"
            }
        }
    }).
    state("front.plan.realtimeclues.suddenclues.customsentiment.mediainfo", {
        url: "/mediainfo?nav",
        views: { //自定义舆情
            "main@front.plan.realtimeclues.suddenclues": {
                templateUrl: "./planningCenter/realTimeClues/suddenClues/customSentiment/mediaInfo/mediaInfo_tpl.html",
                controller: "mediaInfoController"
            }
        }
    });
}]);